import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsShadows = {
	shadow_xs: "rgba(10, 13, 18, 0.05)",
	shadow_sm_1: "rgba(10, 13, 18, 0.1)",
	shadow_sm_2: "rgba(10, 13, 18, 0.1)",
	shadow_md_1: "rgba(10, 13, 18, 0.1)",
	shadow_md_2: "rgba(10, 13, 18, 0.06)",
	shadow_lg_1: "rgba(10, 13, 18, 0.08)",
	shadow_lg_2: "rgba(10, 13, 18, 0.03)",
	shadow_lg_3: "rgba(10, 13, 18, 0.04)",
	shadow_xl_1: "rgba(10, 13, 18, 0.08)",
	shadow_xl_2: "rgba(10, 13, 18, 0.03)",
	shadow_xl_3: "rgba(10, 13, 18, 0.04)",
	shadow_2xl_1: "rgba(10, 13, 18, 0.18)",
	shadow_2xl_2: "rgba(10, 13, 18, 0.04)",
	shadow_3xl_1: "rgba(10, 13, 18, 0.14)",
	shadow_3xl_2: "rgba(10, 13, 18, 0.04)",
	shadow_skeumorphic_inner: "rgba(10, 13, 18, 0.05)",
	shadow_skeumorphic_inner_border: "rgba(10, 13, 18, 0.18)",

	shadow_xs_dark: colors.primary.base.transparent,
	shadow_sm_1_dark: colors.primary.base.transparent,
	shadow_sm_2_dark: colors.primary.base.transparent,
	shadow_md_1_dark: colors.primary.base.transparent,
	shadow_md_2_dark: colors.primary.base.transparent,
	shadow_lg_1_dark: colors.primary.base.transparent,
	shadow_lg_2_dark: colors.primary.base.transparent,
	shadow_lg_3_dark: colors.primary.base.transparent,
	shadow_xl_1_dark: colors.primary.base.transparent,
	shadow_xl_2_dark: colors.primary.base.transparent,
	shadow_xl_3_dark: colors.primary.base.transparent,
	shadow_2xl_1_dark: colors.primary.base.transparent,
	shadow_2xl_2_dark: colors.primary.base.transparent,
	shadow_3xl_1_dark: colors.primary.base.transparent,
	shadow_3xl_2_dark: colors.primary.base.transparent,
	shadow_skeumorphic_inner_dark: colors.primary.base.transparent,
	shadow_skeumorphic_inner_border_dark: colors.primary.base.transparent,
};
